module.exports = __webpack_public_path__ + "static/media/health.f47ab63c.svg";